import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_DATES,
  UPDATE_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_VALUES,
  SET_UPDATES_LOADING
} from "./xponentialPlusSagas";

export const actionCreators = {};

const initialState = {
  isLoading: true,
  filtersDirty: false,
  isUpdating: false,
  currentUser: {},
  date: null,
  dataPoints: { trials: {}, newMembers: {}, activePaying: {}, recurringRevenue: {} }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      isUpdating: action.payload,
      filtersDirty: false
    }),
    [SET_DATES]: (state) => ({
      ...state,
      date: state.currentUser.calendarEndDate
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      date: action.payload,
      filtersDirty: true
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({ ...state, currentUser: action.payload }),
    [FETCH_VALUES]: (state, { payload }) => {
      return {
        ...state,
        dataPoints: payload
      };
    }
  },
  initialState
);
